import algoliasearch from 'algoliasearch/lite'
import SearchProvider from './searchProvider'
import { getConfig } from './config'

export default ({ $config, $sitewideData, nuxtState }) => {
    const client = algoliasearch(
        $sitewideData.config.algoliaAppId,
        $sitewideData.config.algoliaApiKey
    )

    // Loop through the serialized search states and create their client side instances.
    const searchContexts = Object.keys(nuxtState.$search).reduce((acc, key) => {
        acc[key] = new SearchProvider(client, nuxtState.$search[key])
        return acc
    }, {})

    const config = getConfig($config.platform.mode)
    searchContexts.addDynamicContentContext = (id) => {
        if (searchContexts[id]) return searchContexts[id]
        searchContexts[id] = new SearchProvider(client, {
            indexName: config.indexes.content,
        })
        return searchContexts[id]
    }

    searchContexts.addDynamicProductContext = (id) => {
        if (searchContexts[id]) return searchContexts[id]
        searchContexts[id] = new SearchProvider(client, {
            indexName: config.indexes.products,
            params: {
                attributes: [
                    'productLineName',
                    'productLineSlug',
                    'image',
                    'badgeText',
                    'hasDiscount',
                    'isPreOrder',
                    'isNew',
                    'sameDayShipping',
                    'salePrice',
                    'originalPrice',
                    'averageRating',
                    'totalReviews',
                    'productId',
                    'brand', // for Schema markup :(
                    'brandSlug', // for GA :(
                    'skuSlug', // for GA :(
                    'categories', // for GA :(
                ],
                ignorePlurals: ['en'],
                scanDistinctHitsUntilPaginationLimitedTo: true,
            },
        })
        return searchContexts[id]
    }

    return searchContexts
}
